// extracted by extract-css-chunks-webpack-plugin
module.exports = {};
    if(module.hot) {
      // 1793157566125
      var cssReload = require("/var/www/html/moderlab/moderclient/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"reloadAll":true,"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  